<template>
	<section class="main" style="min-height: 500px;">
		<header class="panel-heading">
			<h3 class="panel-title">點名系統</h3>
		</header>
		<section class="panel panel-default" style="margin-bottom: 0px">
			<header class="panel-heading" style="padding: 10px;">
				<div class="panel-actions" style="top: 7px;">
					<a href="#searchArea" data-toggle="collapse" class="panel-action panel-action-toggle"></a>
				</div>
				<h4 class="panel-title">查詢條件</h4>
			</header>
			<div id="searchArea" class="panel-collapse collapse">
				<div class="panel-body">
					<div class="row form-group">
						<div class="col-md-4">
							<label class="col-md-4">宿舍</label>
							<div class="col-md-8">
								<select v-model="bedFloor" class="form-control" @change="getBedRoomList()">
									<option value="">--請選擇--</option>
									<option v-for="(bedFloor, index) in bedFloorList" :key="index" :value="bedFloor">{{bedFloor}}</option>
								</select>
							</div>
						</div>
						<div class="col-md-4">
							<label class="col-md-4">房號</label>
							<div class="col-md-8">
								<select v-model="bedRoom" class="form-control">
									<option value="">--請選擇--</option>
									<option v-for="(bedRoom, index) in tmpBedRoomList" :key="index" :value="bedRoom.bedRoom">{{bedRoom.bedRoom}}</option>
								</select>
							</div>
						</div>
						<div class="col-md-4">
							<label class="col-md-4">簽到情形</label>
							<div class="col-md-8">
								<select v-model="rollcallStatus" class="form-control">
									<option value="">--請選擇--</option>
									<option value="N">未簽到</option>
									<option value="Y">已簽到</option>
									<option value="D">遲到</option>
								</select>
							</div>
						</div>
					</div>
					<div class="row form-group">
						<div class="col-md-4">
							<label class="col-md-4">日期</label>
							<div class="col-md-8">
								<datepicker :format="customFormatter" :language="zh" v-validate="'required'" v-model="rollcallDate" input-class="form-control" :style="{width:'auto', display:'inline-block'}"/>
							</div>
						</div>
						<div class="col-md-4">
							<label class="col-md-4">學號</label>
							<div class="col-md-8">
								<input v-model="account" class="form-control" />
							</div>
						</div>
					</div>
					<div class="row form-group">
						<div class="col-md-4 "></div>
						<div class="col-md-4 ">
							<div class="col-md-offset-3 col-md-6">
								<button type="button" class="btn btn-danger btn-block" @click="updateGrid(1)">查詢</button>
							</div>
						</div>
						<div class="col-md-4 "></div>
					</div>
				</div>
			</div>
		</section>
		<div class="tab-content">
			<div class="tab-pane fade in show" role="tabpanel" aria-labelledby="vacation-tab">
				<div class="row form-group">
					<div class="col-md-12 text-right form-inline" v-if="isAdmin('stay')">
            <label for="fileV" class="btn s_btn_b hidden-xs">匯入不點名日期</label>
            <input id="fileV" ref="fileV" name="file" type="file" value accept=".xls, .xlsx" @change="importNoRollcallDate($event)" style="display: none" />
						<button class="btn btn-danger m-xs" @click="generateDailyRollcallList">產生名單</button>
						<button class="btn btn-danger m-xs" @click="expDailyRollcallList">查詢後匯出</button>
					</div>
				</div>
				<div class="row form-group">
					<div class="col-md-12 form-group">
            <a href="javascript:;" class="btn btn-link" @click="downloadSample">不點名檔案(匯入範例)</a>
						<table class="table table-no-more table-bordered table-striped mb-none" style="width:100% !important;">
							<thead>
								<tr>
									<th class="text-center" style="width:10%">學制</th>
									<th class="text-center" style="width:20%">系科年級</th>
									<th class="text-center" style="width:10%">學號</th>
									<th class="text-center" style="width:20%">姓名</th>
									<th class="text-center" style="width:10%">宿舍</th>
									<th class="text-center" style="width:5%">房號</th>
									<th class="text-center" style="width:5%">床位</th>
									<th class="text-center" style="width:10%">簽到情形</th>
									<th class="text-center" style="width:10%">簽到時間</th>
								</tr>
							</thead>
							<tbody v-for="(item, index) in rollcallRecordGrid.rows" :key="index">
								<tr>
									<td class="text-center" data-title="學制">{{item.deptSsymStr}}</td>
									<td class="text-center" data-title="系科年級">{{item.deptCodeStr}}<br/>{{item.drade}}年{{item.dradeClass}}班</td>
									<td class="text-center" data-title="學號">{{`${item.account}`}}</td>
									<td class="text-center" data-title="姓名">{{`${item.name} - ${item.phone}`}}</td>
									<td class="text-center" data-title="宿舍" >{{item.bedFloor}}</td>
									<td class="text-center" data-title="房號" >{{item.bedRoom}}</td>
									<td class="text-center" data-title="床位" >{{item.bed}}</td>
									<td class="text-center" data-title="簽到情形" v-if="!isAdmin('stay')">
										<a href="javascript:;" class="btn btn-primary btn-block"
											v-if="item.rollcallStatus == 'N' && (customFormatter(item.rollcallDate) == customFormatter(new Date()))"
											@click="rollcallSign(item)">
											簽到
										</a>
										<span v-else>{{item.rollcallStatusStr}}</span>
									</td>
									<td class="text-center" data-title="簽到情形" v-if="isAdmin('stay')">
										<select v-model="item.rollcallStatus" class="form-control" v-if="item.rollcallStatus != 'O'" @change="rollcallSign(item)">
											<option value="">--請選擇--</option>
											<option value="N">未簽到</option>
											<option value="Y">已簽到</option>
											<option value="D">遲到</option>
										</select>
										<span v-else>{{item.rollcallStatusStr}}</span>
									</td>
									<td class="text-center" data-title="簽到時間" >{{item.signDate ? customFormatter(item.signDate, 'YYYY/MM/DD HH:mm:ss') : ""}}</td>
								</tr>
							</tbody>
						</table>
					</div>
					<div class="col-md-12">
						<div class="text-center">
							<pageControl v-bind:page="page" v-bind:total="totalPage"></pageControl>
						</div>
					</div>
				</div>
			</div>
		</div>
		<lateReason v-if="isOpenPopup" v-bind:rollcallRecord="popupParam"/>
	</section>
</template>
<script>
import lateReason from './lateReason'
export default {
	components:{
		lateReason
	},
	mounted(){
		this.rollcallDate = this.dateFormatter(new Date());
		const api = "/api/RollcallRecord/bedList";
		this.$axios.post(api, {}).then(resp => {
			this.bedFloorList = resp.data.data.bedFloorList;
			this.bedRoomList = resp.data.data.bedRoomList;
		});
		this.gridInit();
	},
	data(){
		return{
			page:1,
			pageSize:10,
			totalPage:0,
			bedFloor:"",
			bedRoom:"",
			rollcallStatus:"",
			rollcallDate:"",
			rollcallRecordGrid:{},
			bedFloorList:[],
			bedRoomList:[],
			tmpBedRoomList:[],
			popupParam:{},
			isOpenPopup:false,
			account:"",
		}
	},
	methods:{
		getBedRoomList(){
			this.tmpBedRoomList = this.bedRoomList.filter(item => {
				return item.bedFloor == this.bedFloor
			});
		},
		updateGrid(page) {
			//更新Grid 必需
			this.page = page;
			this.gridInit();
		},
		gridInit(){
			let qryParam = {
				page:this.page,
				pageSize:this.pageSize,
				model:{
					rollcallDate : this.rollcallDate,
					bedFloor : this.bedFloor,
					bedRoom : this.bedRoom,
					rollcallStatus: this.rollcallStatus,
					account:this.account
				}
			};
			if(this.sessionData.accountType == "STU"){
				qryParam.model["mageAccount"] = this.sessionData.account;
			}
			const api = "/api/RollcallRecord/rollcallRecordByGrid";
			this.$axios.post(api, JSON.stringify(qryParam)).then(resp =>{
				this.rollcallRecordGrid = resp.data.data;
				this.totalPage = this.rollcallRecordGrid.total;
				this.page = this.rollcallRecordGrid.page;
				this.pageSize = this.rollcallRecordGrid.pageSize;
			});
		},
		rollcallSign(item){

			if(!this.isAdmin("stay")){
				if(new Date() < this.dDate){
					this.saveRollcallSign(item);
				}else{
					this.popupParam = item;
					this.isOpenPopup = true;
				}
			}else{
				if(item.rollcallStatus == "D"){
					this.popupParam = item;
					this.isOpenPopup = true;
				}else{
					this.saveRollcallSign(item);
				}
			}
		},
		saveRollcallSign(item){
			item.signDate = new Date();
			if(!this.isAdmin("stay")){
				if( new Date() < this.dDate){
					item.rollcallStatus = "Y";
					item.rollcallStatusStr = "已簽到";
				}else{
					item.rollcallStatus = "D";
					item.rollcallStatusStr = "遲到";
				}
			}
			const api = "/api/RollcallRecord/updRollcalRecordStatus";
			this.$axios.post(api, JSON.stringify(item)).then(resp =>{
				if(resp.data.status == "success"){
					this.updateGrid(this.page);
					this.isOpenPopup = false;
					if(item.rollcallStatus == "N"){
						item.signDateCht = "";
					}
				}
			});
		},
		expDailyRollcallList() {
			const api = "/api/RollcallRecord/expDailyRollcallList";
			this.$axios.post( api, JSON.stringify({
				rollcallDate : this.rollcallDate,
				bedFloor : this.bedFloor,
				bedRoom : this.bedRoom,
				rollcallStatus: this.rollcallStatus
			}), {
				headers: { "Content-Type": "application/json" },
				responseType: "blob"
			}).then(resp => {
				const url = window.URL.createObjectURL(new Blob([resp.data]));
				const link = document.createElement("a");
				link.href = url;
				link.setAttribute("download", "點名名冊_"+this.customFormatter(new Date(),"YYYYMMDD")+".xlsx");
				document.body.appendChild(link);
				link.click();
			});
		},
    importNoRollcallDate(e) {
      const api = "/api/RollcallRecord/importNoRollcallDate";
      let excelFile = e.target.files[0];
      let formData = new FormData();
      formData.append("file", excelFile);
      this.$axios.post(api, formData).then(resp => {
        if (resp.data.status === "success") {
          bootbox.alert(resp.data.msg.replace(new RegExp("\r?\n", "g"), "<br />" ));
          this.selectionDormitoryType();
        } else {
          bootbox.alert(resp.data.msg.replace(new RegExp("\r?\n", "g"), "<br />"));
        }
      });
      e.target.value = "";
    },
		generateDailyRollcallList(){
			const api = "/api/RollcallRecord/testGenerateDailyRollcallList";
			this.$axios.post(api, JSON.stringify({}));
		},
		updDailyRollcallListBy23H(){
			const api = "/api/RollcallRecord/testUpdDailyRollcallList";
			this.$axios.post(api, JSON.stringify({}));
		},
		showPopupControl(isOpen){
			this.isOpenPopup = isOpen;
		},
    downloadSample(){
      const api = `/api/Common/downloadFile/不點名匯入Template.xlsx`;
      this.$axios.post( api, null, {
        headers: { "Content-Type": "application/json" },
        responseType: "blob"
      }).then(resp => {
        const url = window.URL.createObjectURL(new Blob([resp.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "不點名匯入範例.xlsx");
        document.body.appendChild(link);
        link.click();
      });
    },
	},
	computed:{
		dDate(){
			return new Date(this.customFormatter(new Date()) + " 23:30:00");
			// return new Date(this.customFormatter(new Date()) + " 15:01:00");
		}
	}
}
</script>
